import { render, staticRenderFns } from "./WhatsNewReleaseDrawer.vue?vue&type=template&id=3057a9a7&scoped=true"
import script from "./WhatsNewReleaseDrawer.vue?vue&type=script&lang=js"
export * from "./WhatsNewReleaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewReleaseDrawer.vue?vue&type=style&index=0&id=3057a9a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057a9a7",
  null
  
)

export default component.exports